var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-breadcrumb',{staticClass:"breadcurmb",attrs:{"separator-class":"el-icon-caret-right"}},[_c('el-breadcrumb-item',[_c('i',{staticClass:"el-icon-s-home"}),_vm._v(" 首页")]),_vm._l((_vm.currentPath),function(list){return _c('el-breadcrumb-item',[_vm._v(_vm._s(list))])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }